<template>
  <div id="detail-order-list" class="list">
    <div class="detail-order-list-header list-header">
      <ul>
        <li>{{$_('customer_product_reference')}}</li>
        <li>{{$_('satab_product_reference')}}</li>
        <li>{{$_('size')}}</li>
        <li>{{$_('color')}}</li>
        <li>{{$_('packaging')}}</li>
        <li>{{$_('quantity_ordered')}}</li>
        <li>{{$_('quantity_allocated')}}</li>
        <li>{{$_('quantity_shipped')}}</li>
        <li>{{$_('submission')}}</li>
        <li>{{$_('satab_start_titme')}}</li>
      </ul>
    </div>
    <div class="detail-order-list-body list-body">
      <div v-for="(item, index) in items" :key="index">
        <DetailOrderLine :dataline="item" />
      </div>
    </div>
  </div>
</template>

<script>
import DetailOrderLine from "./DetailOrderLine";
import orderService from '../services/orderService';

export default {
  name: "OrderList",
  components: {
    DetailOrderLine
  },
  data() {
    return {
      items: []
    };
  },
  created() {
    this.vGetOrderDetails();
  },
  computed: {
    getDetailResearch() {
      return this.$store.getters['commande/get_detail_research'];
    }
  },
  watch: {
    getDetailResearch(val) {
      if (val) {
        this.vGetOrderDetails();
      }
    }
  },  
  methods: {
    vGetOrderDetails() {

      this.items = Array();

      orderService.getDetailOrder({
        frefc: this.$store.getters['commande/get_detail_fref'] ? this.$store.getters['commande/get_detail_fref'] : null,
        fmod: this.$store.getters['commande/get_detail_fmod'] ? this.$store.getters['commande/get_detail_fmod'] : null ,
        fcol: this.$store.getters['commande/get_detail_fcol'] ?  this.$store.getters['commande/get_detail_fcol'] : null ,
        ftail: this.$store.getters['commande/get_detail_ftail'] ?  this.$store.getters['commande/get_detail_ftail'] : null ,
        pnocde: this.$route.params.order_id
      })
      .then( res => {
        if(res.data.DS_O !== undefined) {

          res.data.DS_O.OUT.map(obj => {
            this.items.push(obj);
          });
        }

        this.$store.dispatch('commande/LAUNCH_DETAIL_RESEARCH', {launch_detail_research: false});

      }).catch( err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
#detail-order-list {
  padding: 0px 20px;
}
.detail-order-list-header ul {
  display: flex;
  align-items: center;
}
.detail-order-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 10);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.detail-order-list-header {
  padding: 20px 0px;
}
</style>